import { types } from 'mobx-state-tree'

const FailedNotificationReportConfig = types.model('FailedNotificationReportConfig', {
  id: types.identifierNumber,
  notificationConfig: types.number
})

export type IFailedNotificationReportConfig = typeof FailedNotificationReportConfig.Type
export default FailedNotificationReportConfig